<template>
  <nav class="level app-levelbar">
    <div class="level-left">
      <div class="level-item">
        <div class="subtitle is-5">
          <strong>{{ name }}</strong>
        </div>
      </div>
    </div>

    <div class="level-right is-hidden-mobile">
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </div>
  </nav>
</template>

<script>
export default {
  data () {
    return {
      items: null
    }
  },

  computed: {
    name () {
      const name = this.$route.meta.label || this.$route.name
      return this.capitalize(this.$t(name))
    }
  },

  watch: {
    $route () {
      this.getItems()
    }
  },

  created () {
    this.getItems()
  },

  methods: {
    getItems () {
      const route = this.$route.matched.filter(item => item.name)
      let items = route.map(({ name, path }) => ({ text: this.capitalize(this.$t(name)), to: path }))

      const first = route[0]
      if (first && (first.name !== 'Home' || first.path !== '')) {
        items = [{ text: 'Home', to: '/' }].concat(items)
      }
      this.items = items
    },
    capitalize (str) {
      if (typeof str !== 'string') return ''
      return str.charAt(0).toUpperCase() + str.slice(1)
    }
  }
}
</script>
<style lang="scss">
  .level.app-levelbar {
    margin: 5px 0 12px;

    .v-breadcrumbs {
      padding: 5px 0 0 0;

      li.v-breadcrumbs__divider {
        padding: 0 6px;
      }
    }
  }
</style>
